<p-dialog class="notification-popup" 
    header="Submit feedback" 
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="true" 
    [style]="{width: '800px', height: '550px'}" 
    (onHide)="onCloseModal()">

    <div class="content-section">  
        <div class="header">
            <span>Please review the responses provided before submitting your feedback.</span>
        </div>
        <div class="body">
            <div *ngIf="hasHighlightedData" class="highlighted-body-content">
            <!-- <div *ngIf="hasHighlightedData()" class="highlighted-body-content"> -->
                <div class="highlighted-feedback-summary">
                    <div *ngFor="let item of highlightedsummaryData" class="summary-item highlighted-item">
                        <strong>{{ item.fieldDescription }}:</strong> <span>{{ item.value }}</span>
                    </div>
                </div>

            </div>
            <div *ngIf="hasFeedbackData" class="body-content">
            <!-- <div *ngIf="hasFeedbackData()" class="body-content"> -->
                <div class="feedback-summary">
                    <div *ngFor="let item of summaryData" class="summary-item">
                        <strong>{{ item.fieldDescription }}:</strong> {{ item.value }}
                    </div>
                </div>
            </div>
            <div *ngIf="!hasFeedbackData" class="no-feedback-data">
            <!-- <div *ngIf="!hasFeedbackData()"> -->
                <span>No feedback data available.</span>
            </div>

        </div>
    </div>

    <div class="buttons-section">
        <div class="button-container">
            <button class="reset-button formated-button" 
            (click)="onCloseModal()">Close</button>
        </div>
        
        <div class="button-container">
            <button class="close-button formated-button" 
            (click)="onSubmitForm()">Submit</button>
        </div>
      
    </div>

</p-dialog>